export default function IconArrowRight({
    className,
    ariaLabel
}: {
    className?: string
    ariaLabel?: string
}) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label={ariaLabel}
        >
            <path
                d="M18 6L16.57 7.393L24.15 15H4V17H24.15L16.57 24.573L18 26L28 16L18 6Z"
                fill="currentColor"
            />
        </svg>
    )
}
